import { CheckIcon, CalendarIcon } from "@chakra-ui/icons";
import {
  Box,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  Badge,
  Spinner,
  Icon,
} from "@chakra-ui/react";
import { ClockIcon } from "@mui/x-date-pickers/icons";
import { KYDContactImportJob } from "common/interfaces/KYDCampaign";
import dayjs from "dayjs";
import { formatDate } from "src/utils";
import { KYDScope } from "@common/interfaces/ICognito";

const columns: {
  key: keyof any | "spacer";
  label: string;
  isNumeric?: boolean;
}[] = [
  { key: "name", label: "Name" },
  { key: "size", label: "Contacts", isNumeric: true },
  { key: "status", label: "Status", isNumeric: true },
  { key: "finished_at", label: "Date", isNumeric: true },
];

export const ContactImportsTable = ({
  rows,
  permissions,
}: {
  rows: KYDContactImportJob[];
  permissions: KYDScope[];
}) => {
  return (
    <Box
      w="100%"
      overflowX="auto"
      borderTop="1px solid"
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      {/* {editingSegmentId && (
        <CreateNewSegmentDialog
          isOpen={!!editingSegmentId}
          close={handleCloseEdit}
          segment={rows.find((row) => row.id === editingSegmentId)}
        />
      )} */}
      <Table variant="simple" w="100%">
        <Thead>
          <Tr height="40px">
            {columns.map(({ key, label, isNumeric }) => (
              <Th
                key={key.toString()}
                textTransform="uppercase"
                fontSize="12px"
                fontWeight="700"
                letterSpacing="0.5px"
                color="gray.700"
              >
                <HStack spacing={1}>
                  <Text whiteSpace="nowrap">{label}</Text>
                </HStack>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((row) => (
            <Tr
              key={row.id}
              _hover={{ bg: "gray.50" }}
              style={{ textDecoration: "none", width: "100%" }}
            >
              <Td py={8} p={6}>
                <VStack align="flex-start" spacing={1}>
                  <Text w="100%" fontSize="14px" fontWeight="500" h="100%">
                    {row.name}
                  </Text>
                </VStack>
              </Td>
              <Td>{row.total_contacts?.toLocaleString() || "0"}</Td>
              <Td>
                <Badge
                  colorScheme={
                    row.status === "ERROR"
                      ? "red"
                      : row.status === "COMPLETED"
                        ? "green"
                        : "yellow"
                  }
                >
                  <HStack>
                    {row.status === "PROCESSING" ? (
                      <Spinner size="sm" />
                    ) : row.status === "ERROR" ? null : row.status ===
                      "COMPLETED" ? (
                      <Icon as={CheckIcon} />
                    ) : row.status === "SCHEDULED" ? (
                      <Icon as={CalendarIcon} />
                    ) : null}
                    <Text>{row.status}</Text>
                  </HStack>
                </Badge>
              </Td>
              <Td>{formatDate(dayjs(row.created_at))}</Td>
              <Td></Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
